import { App } from '@capacitor/app';

class OfflineHandler {
  async initialize(): Promise<void> {
    // Handle Android back button
    App.addListener('backButton', ({ canGoBack }) => {
      if (canGoBack) {
        window.history.back();
      } else {
        // Show exit confirmation
        if (confirm('Exit app?')) {
          App.exitApp();
        }
      }
    });

    console.log('✅ Back button handler registered');
  }
}

export const offlineHandler = new OfflineHandler();
